<template>
    <div class="application-footer-container">
        <v-footer app padless fixed color="primary">
            <v-row justify="center" no-gutters>
                <v-col cols="12" sm="12">
                    <v-card color="primary" dark class="text-center">
                        <v-card-text>{{ copyright }}</v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-footer>
    </div>
</template>

<script lang="ts">
    import { Vue, Component } from 'vue-property-decorator';

    @Component
    export default class ApplicationFooter extends Vue {
        copyright: string = `SBS © ${new Date().getFullYear()}`;
    }
</script>

<style scoped>

</style>